import {
  TNotification,
  TNotificationsState,
} from '@/redux/slices/notifications/types';
import { createSlice } from '@reduxjs/toolkit';

export const initialState: TNotificationsState = {
  notifications: [],
};

export const notificationsSlice = createSlice({
  name: 'notificationsSlice',
  initialState,
  reducers: {
    addNotification: (state, { payload }: { payload: TNotification }) => {
      state.notifications.push(payload);
    },
    removeNotification: (state, { payload }: { payload: string }) => {
      state.notifications = state.notifications.filter((n) => n.id !== payload);
    },
  },
});

export default notificationsSlice.reducer;
export const { addNotification, removeNotification } =
  notificationsSlice.actions;
